module.exports = __webpack_public_path__ + "static/media/loader.5f8267ac.gif";